export default {
  documents: 'Documents',
  login: 'Login',
  malls: 'Malls',
  news: 'News',
  brands: 'Brands',
  users: 'Users',
  entries: 'Entries',
  user: {
    myHome: 'MyHome',
    myEntries: 'MyEntries',
    myDocuments: 'MyDocuments',
    myProfile: 'MyProfile'
  }
}